export const vs_amounts_options = (amounts_options) => {
    let options = [];
    const objectArray = Object.entries(amounts_options || {});
    // eslint-disable-next-line no-unused-vars
    objectArray.forEach(([key, value],i) => {
      options.push({ id: i, price: value });
    });
    return options;
};
  